<template>
  <div class="w-100 transition">
    <GenericReport
      title="Relatório de encerramento de ciclos forçados"
      :route="route"
      :topFilters="topFilters"
      :sideFilters="sideFilters"
      :fields="fields"
      tipoRelatorio="encerramentosForcados"
    />
  </div>
</template>

<script>
import moment from 'moment';

import GenericReport from '@/components/Table/GenericReport';

export default {
  name: 'relatorioEncerramentosForcados',
  components: {
    GenericReport,
  },
  data() {
    return {
      route: 'report/encerramentosForcados',
      topFilters: {
        id_unidade: {
          type: 'genericSelect',
          route: 'unidade',
          firstOption: {
            value: null,
            label: 'Unidade',
          },
        },
        id_sub_setor: {
          type: 'genericSelect',
          route: 'subSetor',
          firstOption: {
            value: null,
            label: 'Área',
          },
        },
        id_tipo_processo: {
          type: 'select',
          firstOption: {
            value: null,
            label: 'Processo',
          },
        },
        date: {
          type: 'rangeDate',
          defaultInitDate: moment().subtract(7, 'days'),
          defaultEndDate: moment(),
        },
      },
      sideFilters: {
        id: {
          type: 'input',
          label: 'ID',
        },
        descricao: {
          type: 'input',
          label: 'Descrição',
        },
        id_tipo_material: {
          type: 'genericSelect',
          label: 'Tipo de Material',
          route: 'tipoMaterial',
        },
      },
      fields: [
        {
          label: 'Tipo de material',
          key: 'tipoMaterial',
          formatter: (value) => value && value.nome,
        },
        {
          label: 'ID',
          key: 'shownId',
        },
        {
          label: 'Descrição',
          key: 'descricao',
        },
        {
          label: 'Cor',
          key: 'cor',
        },
        {
          label: 'Data/Hora',
          key: 'forcedDate',
          formatter: (value) => moment(value).format('DD/MM/YY HH:mm'),
        },
        {
          label: 'Usuário',
          key: 'usuario',
          formatter: (value) => value && value.nome,
        },
        {
          label: 'Última Área',
          key: 'subSetor',
          formatter: (value) => value && value.nome,
        },
        {
          label: 'Último Processo',
          key: 'tipoProcesso',
          formatter: (value) => value && value.nome,
        },
        {
          label: 'Justificativa',
          key: 'justificativa',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
$primary-color-50: #209f85;

.paginador {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.transition {
  transition: 0.3s ease-in-out;
}

#report h2 {
  margin-bottom: 30px;
}

#report table {
  background-color: #fff;
}

#report table thead th {
  color: #7e829f;
  padding-bottom: 50px;
  font-weight: 900;
}
</style>
